/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Consumption_Comparison_Overlaps_PeriodInputs */



/**
* | output |
* | --- |
* | "The displayed period is longer than the chosen gap: it would overlap the compared period." |
*
* @param {Consumption_Comparison_Overlaps_PeriodInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const consumption_comparison_overlaps_period = /** @type {((inputs?: Consumption_Comparison_Overlaps_PeriodInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Consumption_Comparison_Overlaps_PeriodInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("The displayed period is longer than the chosen gap: it would overlap the compared period.")
	return /** @type {LocalizedString} */ ("La période affichée est plus longue que l'écart choisi : elle chevaucherait la période comparée.")
});